import { render, staticRenderFns } from "./vipIntentionFundList.vue?vue&type=template&id=1201e0c8&scoped=true&"
import script from "./vipIntentionFundList.vue?vue&type=script&lang=js&"
export * from "./vipIntentionFundList.vue?vue&type=script&lang=js&"
import style0 from "./vipIntentionFundList.vue?vue&type=style&index=0&id=1201e0c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1201e0c8",
  null
  
)

export default component.exports